import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ContactForm from "./ContactForm";

import ArrowBg from "../../../components/arrow-bg/ArrowBg";
import {useWindowWidth} from "../../../services/useWindowWidth";

import styles from './Contacts.module.scss';

const SuccessScreen = () => {
    return (
        <Row className="justify-content-center">
            <Col xs={{ span: 10 }}>
                <h2 className={styles.resultSubtitle}>Спасибо!</h2>
                <p className={styles.resultText}>Ваша заявка принята. Благодарим за&nbsp;интерес к&nbsp;нашему сервису. Мы&nbsp;отправим уведомление, как только демо-версия будет доступна.</p>
            </Col>
        </Row>
    );
}

const ErrorScreen = () => {
    return (
        <Row className="justify-content-center">
            <Col xs={{ span: 10 }}>
                <h2 className={styles.resultSubtitle}>Извините, произошла ошибка!</h2>
                <p className={styles.resultText}>Попробуйте, пожалуйста, еще раз.</p>
            </Col>
        </Row>
    );
}

function Contacts() {

    const [isSuccess, setIsSuccess] = React.useState(false);
    const [isError, setIsError] = React.useState(false);

    const width = useWindowWidth();

    return (
        <ArrowBg bgImageStyles={{
            top: width >= 768 ? '-44.1%' : '0',
            left: width >= 768 ? '-62.2%' : '0'
        }}>
            <div className={styles.contacts} id='contacts'>
            <Container className={styles.contactsContainer}>
                <Row>
                    <Col xs={12}>
                        <h2 className={styles.title}>Контакты</h2>
                        <p className={styles.text}>
                            Остались вопросы? Пишите!
                        </p>
                    </Col>
                </Row>
                {isSuccess && <SuccessScreen />}
                {isError && <ErrorScreen />}
                {!isSuccess && !isError &&
                    <ContactForm
                        onSuccess={(value) => setIsSuccess(value)}
                        onError={(value) => setIsError(value)}
                        hasComment
                    />}
                <Row>
                    <Col xs={12}>
                        <h5 className={styles.companyName}>© 2026 Вэдмаркет</h5>
                    </Col>
                </Row>
            </Container>
        </div>
        </ArrowBg>
    );
}

export default Contacts;
